import Employee from "../../../app/domain/Employee";

export default function adaptEmployeesForEdition({
  employees,
  benefitPlan,
  taxRegime,
}: {
  employees: Employee[];
  benefitPlan: string;
  taxRegime: string;
}) {
  const employeesWithNewKeys = employees.map((employee) => ({
    ...employee,
    modelId: benefitPlan,
    taxRegime,
  }));

  return employeesWithNewKeys.map((employee) => ({
    ...Object.keys(employee).reduce((acc, curr) => {
      if (employee[curr] && employee[curr] !== null && employee[curr] !== "") {
        return { ...acc, [curr]: employee[curr] };
      }
      return acc;
    }, {}),
    grossSalary: employee.grossSalary || "REDACTED",
  }));
}
